import { Component, OnInit } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { ContactResponse, ContactService } from "src/app/services/contact.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-contact",
  templateUrl: "./contact.component.html",
})
export class ContactComponent implements OnInit {
  navbarOpen = false;
  contactForm: FormGroup;
  contactResponse: ContactResponse | undefined;
  sentiment: string;

  constructor(private contactService: ContactService, private _snackBar: MatSnackBar) {
  }

  ngOnInit(): void {
    this.contactForm = new FormGroup({
      fcname: new FormControl("", [
        Validators.required,
        notEmptyStringValidator()
      ]),
      fcemail: new FormControl("", [
        Validators.required,
        Validators.email,
      ]),
      fcmessage: new FormControl("", [
        Validators.required,
        notEmptyStringValidator(),
        minLengthStringValidator(10)
      ]),
    });
  }

  get fcname() { return this.contactForm.get("fcname"); }

  onMessageTextChange(currentMessage: string) {
    //   if (currentMessage.length < 10)
    //     return;
    // this.contactService
    //   .getSentiment(currentMessage)
    //   .subscribe((data) => {
    //     const ratingStr = (data as any).outputs.result[0].label.split(" ")[0];
    //     const rating = parseInt(ratingStr, 10);
    //     console.log(rating);

    //     if (rating >= 4)
    //       this.sentiment = "positive";
    //     else if (rating <= 2)
    //       this.sentiment = "negative";
    //     else {
    //       this.sentiment = "neutral";
    //     }
    //   });
  }

  async submitContact() {
    const name = this.contactForm.get("fcname").value;
    const email = this.contactForm.get("fcemail").value;
    const message = this.contactForm.get("fcmessage").value;

    const snackBarDurationSeconds = 3;

    let snackMsg = "Su mensaje ha sido enviado satisfactoriamente :)"
    try {
      this.contactResponse = await this.contactService.createContactMessage(name, email, message)
    } catch (error) {
      snackMsg = "Ha ocurrido un error en el envío :(. Por favor contáctenos si el error persiste."
    }

    this._snackBar.open(snackMsg, "", { duration: snackBarDurationSeconds * 1000 })
      .afterDismissed()
      .subscribe((_) => this.contactForm.reset());

    // Another option in case we don't want a typed version is:
    // .subscribe(data => this.config = {
    //   heroesUrl: (data as any).heroesUrl,
    //   textfile:  (data as any).textfile,
    // });
  }
}

/** A string can't be empty */
export function notEmptyStringValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const forbidden = control.value !== null && control.value !== undefined
      ? control.value.trim().length === 0
      : true;
    return forbidden ? { notEmptyString: { value: control.value } } : null;
  };
}

/** A string's length should be greater or equal the minimum accepted length. */
export function minLengthStringValidator(minLength: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const forbidden = control.value !== null && control.value !== undefined
      ? control.value.trim().length < minLength
      : true;
    return forbidden ? { minLengthString: { value: control.value } } : null;
  };
}
